import { useState } from "react";
import { Card, Tabs, useMantineTheme } from "@mantine/core";
import ClientList from "./ClientList";
import { MemberStatus } from "src/generated/graphql";

export enum TabsName {
  ACCOUNTS = "Members",
  LEAD = "Leads",
  GUESTS = "Guests",
}

const AccountsManagement = () => {
  const theme = useMantineTheme();
  let border = `solid ${theme.colors.primary[6]}`;
  let bg = theme.colors.secondary[2];
  let color = theme.colors.secondaryTextColor[6];

  const [currentTab, setCurrentTab] = useState<TabsName>(TabsName.ACCOUNTS);
  const updateTab = (tabName: TabsName) => {
    setCurrentTab(tabName);
  };

  return (
    <Card
      style={{
        //border: `1px ${border}`,
        color,
        overflow: "hidden",
      }}
      radius="md"
      w="100%"
      p={0}
      bg="transparent"
    >
      <Tabs
        defaultValue="Overview"
        styles={{
          tabsList: {
            color,
            padding: "0 15px",
          },
          tab: {
            marginBottom: -2.5,
            fontWeight: 500,
            borderBottomWidth: 3,
          },
          panel: {
            padding: 15,
          },
        }}
        value={currentTab}
        onTabChange={updateTab}
      >
        <Tabs.List bg={bg}>
          {Object.values(TabsName).map((e) => (
            <Tabs.Tab
              key={e}
              value={e}
              style={{
                color: theme.colors.secondaryTextColor[2],
              }}
              sx={{
                "&:hover": {
                  color: `${theme.colors.primary[4]} !important`,
                  borderColor: `${theme.colors.primary[4]} !important`,
                },
              }}
            >
              {e}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        <Tabs.Panel value={TabsName.ACCOUNTS}>
          <ClientList memberStatus={MemberStatus.Member} />
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.LEAD}>
          {currentTab === TabsName.LEAD && (
            <ClientList memberStatus={MemberStatus.Lead} />
          )}
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.GUESTS}>
          {currentTab === TabsName.GUESTS && (
            <ClientList memberStatus={MemberStatus.Guest} />
          )}
        </Tabs.Panel>
      </Tabs>
    </Card>
  );
};

export default AccountsManagement;
